import { useState, type FC } from 'react';

import type { Register, RegisterDialog } from '../../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { HNHelseregistreJS } from '../../../../types/Resources';

import Button from '@helsenorge/designsystem-react/components/Button';
import Modal from '@helsenorge/designsystem-react/components/Modal';

import { BestillingerStatus } from './bestillinger-status';
import InnsynForesporselModal from './innsyn-foresporsel-modal';
import { useAppDispatch } from '../../../store/hooks';
import { loadingstate, REGISTER_INNSYN_RESET } from '../register-melding';
import { harApenDialog } from '../utils';

export interface Props {
  resources: HNHelseregistreJS;
  dialogTyper: RegisterDialog;
  register: Register;
  loading: boolean;
  innsendingStatus?: loadingstate;
  innsynForesporselError: boolean;
  processingRegisterId: string | null;
}

const BestillInnsynComponent: FC<Props> = ({
  resources,
  dialogTyper,
  register,
  loading,
  innsendingStatus,
  innsynForesporselError,
  processingRegisterId,
}) => {
  const dispatch = useAppDispatch();

  const [visDialogModal, setVisDialogModal] = useState<boolean>(false);

  const visDialogConfirm = innsendingStatus === loadingstate.done && processingRegisterId === register.registerId;

  const closeDialogModal = (): void => {
    if (innsendingStatus === loadingstate.done || innsendingStatus === loadingstate.error) {
      dispatch(REGISTER_INNSYN_RESET());
    }
    setVisDialogModal(false);
  };

  const closeDialogConfirm = (): void => {
    dispatch(REGISTER_INNSYN_RESET());
    setVisDialogModal(false);
  };

  const closeDialogError = (): void => {
    dispatch(REGISTER_INNSYN_RESET());
    setVisDialogModal(false);
  };

  const dialogTypes = dialogTyper ? dialogTyper.dialogTypes : null;

  return (
    <>
      <BestillingerStatus dialogTypes={dialogTypes} resources={resources} />
      <Button
        disabled={!harApenDialog(dialogTyper)}
        onClick={(): void => {
          setVisDialogModal(true);
        }}
      >
        {resources.bestillInnsynsRapport}
      </Button>
      {visDialogModal && !visDialogConfirm && (
        <InnsynForesporselModal
          register={register}
          resources={resources}
          closeDialogModal={closeDialogModal}
          dialogTypes={dialogTypes}
          loading={loading}
        />
      )}
      {visDialogConfirm && (
        <Modal onClose={closeDialogConfirm} title={resources.bestillInnsynKvitteringsHeader} onSuccess={closeDialogConfirm}>
          {resources.bestillInnsynKvitteringsTekst}
        </Modal>
      )}
      {innsynForesporselError && (
        <Modal title={resources.default_ErrorMessage_Title} variant="error" onClose={closeDialogError} onSuccess={closeDialogError}>
          {resources.default_ErrorMessage_Body}
        </Modal>
      )}
    </>
  );
};

export default BestillInnsynComponent;
